// extracted by mini-css-extract-plugin
export default {"box":"index_box_3jmfp","title":"index_title_uEGmZ"};